import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=035b9367&scoped=true&functional=true&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "035b9367",
  null
  
)

export default component.exports